import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

const maintenanceMode = true;

router.beforeEach((to, from, next) => {
  if (maintenanceMode && to.path !== '/m') {
    next('/m');
  } else {
    next();
  }
});

loadFonts()

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(LoadingPlugin, {
    color: 'black',
    width: 64,
    height: 64,
    backgroundColor: '#ffffff',
    opacity: 0.5,
    zIndex: 9999,
    lockScroll: true
  })
  .mount('#app')